export enum Weekdays {
  Sunday = 'sunday',
  Monday = 'monday',
  Tuesday = 'tuesday',
  Wednesday = 'wednesday',
  Thursday = 'thursday',
  Friday = 'friday',
  Saturday = 'saturday',
}

export enum WeekdayIndexEnum {
  Sunday = 0,
  Monday = 1,
  Tuesday = 2,
  Wednesday = 3,
  Thursday = 4,
  Friday = 5,
  Saturday = 6,
}

export const WeekdayIndexMap = new Map<Weekdays, WeekdayIndexEnum>([
  [Weekdays.Sunday, WeekdayIndexEnum.Sunday],
  [Weekdays.Monday, WeekdayIndexEnum.Monday],
  [Weekdays.Tuesday, WeekdayIndexEnum.Tuesday],
  [Weekdays.Wednesday, WeekdayIndexEnum.Wednesday],
  [Weekdays.Thursday, WeekdayIndexEnum.Thursday],
  [Weekdays.Friday, WeekdayIndexEnum.Friday],
  [Weekdays.Saturday, WeekdayIndexEnum.Saturday],
]);
